class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
          .then((response) => response.text())
          .then((responseText) => {
        	
      });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
      // Shopify.getCart((cart) => {window.sharedFunctions?.updateSidebarCart(cart)});
      Shopify.getCart((cart) => {
  window.sharedFunctions?.updateSidebarCart(cart);
  document.dispatchEvent(new Event('cart:refresh'));
});
    })
  }
}

customElements.define('coupon-code', CouponCode);




// custom progress cart sidebar
function updateCartOfferUI(cart) {
  const wrapper = document.querySelector('[data-cart-offer]');
  if (!wrapper) return;

  /* 🔥 HIDE OFFER WHEN CART IS EMPTY */
  if (cart.item_count === 0) {
    wrapper.style.display = "none";
    return;
  } else {
    wrapper.style.display = "block";
  }

  const message = wrapper.querySelector('[data-offer-message]');
  const lineFill = wrapper.querySelector('.offer-line-fill');
  const dots = wrapper.querySelectorAll('.offer-dot');

  const JEWELLERY_COLLECTION_ID = 462208401661;

  let nonJewelleryCount = 0;
  let hasJewellery = false;

  /* ✅ COUNT NON-JEWELLERY PRODUCTS */
  cart.items.forEach(item => {

    const collections = item.collections || [];

    const isJewellery = item.product_type === "Earring"

    if (isJewellery) {
      hasJewellery = true;
    } else {
      nonJewelleryCount += item.quantity;
    }
  });

  let percent = 0;
  let text = "";

  /* 🔥 DISCOUNT LOGIC */
  if (nonJewelleryCount >= 3) {
    percent = 100;
    text = "You unlocked 25% discount 🎉";
  } 
  else if (nonJewelleryCount === 2) {
    percent = 66;
    text = "Add 1 more product to unlock 25% discount";
  } else if (nonJewelleryCount === 1) {
    percent = 33;
    text = "Add 1 more product to unlock 18% discount";
  }  else {
    percent = 0;
    text = "Add products to unlock discounts";
  }

  if (message) message.innerText = text;
  if (lineFill) lineFill.style.width = percent + "%";

  dots.forEach(dot => {
    const step = Number(dot.dataset.step);
    dot.classList.toggle('active', nonJewelleryCount >= step);
  });
}

/* INITIAL LOAD */
document.addEventListener('DOMContentLoaded', () => {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => updateCartOfferUI(cart));
});

/* HOOK INTO HALO SIDEBAR UPDATE */
if (window.sharedFunctions?.updateSidebarCart) {
  const originalUpdate = window.sharedFunctions.updateSidebarCart;

  window.sharedFunctions.updateSidebarCart = function(cart) {
    originalUpdate(cart);

    /* IMPORTANT: wait for sidebar DOM replace */
    requestAnimationFrame(() => {
      updateCartOfferUI(cart);
    });
  };
}

/* RUN ON PAGE LOAD */
document.addEventListener("DOMContentLoaded", function () {
  refreshCartOffer();
  observeCartChanges();
});


function refreshCartOffer() {
  fetch("/cart.js")
    .then(res => res.json())
    .then(cart => {
      updateCartOfferUI(cart);
    });
}


/* OBSERVE ONLY CART ITEMS WRAPPER */
function observeCartChanges() {
  const cartWrapper = document.querySelector(".previewCart-wrapper");

  if (!cartWrapper) return;

  const observer = new MutationObserver(function () {
    refreshCartOffer();
  });

  observer.observe(cartWrapper, {
    childList: true,
    subtree: true
  });
}



